import FormacaoCargaView from '@/views/formacao-carga/FormacaoCargaView.vue'
import ManutFormacaoCargaView from '@/views/formacao-carga/ManutFormacaoCargaView.vue'

export default [
  {
    path: "/formacao-carga",
    name: "Coasul - Formação de Carga",
    component: FormacaoCargaView,
    meta: {
      requiresAuth: true,
      sync: true,
      online: false
    },
  },  
  {
    path: "/formacao-carga/:id",
    name: "Coasul - Formação de Carga",
    component: ManutFormacaoCargaView,
    meta: {
      requiresAuth: true,
      sync: true,
      online: false
    },
  },  
];
